// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2492":"e49ff085e510e697","2888":"324a22b87d583e06"}[chunkId] + ".css";
};